module.exports = __webpack_public_path__ + "img/yzsdermyy.9ec6e362.png";